export const qaPrefix = 'reqf-xero-contact-address-search-popup';
